<template>
    <div v-loading="loading" class="container-fluid mt-6 px-5">
        <soft-button color="secondary" @click="goBack">
            <i class="fa fa-arrow-left"></i>&nbsp;Geri
        </soft-button>
        <div class="row mt-4">
            <div class="col-md-12">
                <participant-info :participantData="participantData" :lastStatus="lastStatus"
                    @edit="openEditParticipant" />
            </div>
        </div>
        <div class="row mt-4 align-items-start">
            <div class="col-md-6 d-flex flex-column gap-4">
                <div class="card">
                    <div class="card-body py-3" style="padding: 16px 12px;">
                        <div class="d-flex justify-content-between align-items-start mb-0">
                            <titles style="margin: 0;" text="Razılaşma" />
                            <div class="d-flex align-items-center">
                                <div v-if="agreementForm?.createdBy || agreementForm?.updatedBy"
                                    class="record-label-wrapper position-relative" style="margin-right:12px">
                                    <el-button type="default" size="large" text style="padding: 0px;" :icon="InfoFilled"
                                        class="fs-5"></el-button>
                                    <div class="record-label-tooltip">
                                        <record-label :created="agreementForm.createdBy"
                                            :updated="agreementForm.updatedBy"
                                            style="color: #606266; font-size: 14px;" />
                                    </div>
                                </div>
                                <el-button class="fs-5" type="text" style="padding: 0px;" :icon="Edit"
                                    title="Düzəliş et" size="large" :disabled="lastStatus === 50"
                                    @click="openAgreementDialog">
                                </el-button>
                            </div>
                        </div>
                        <hr style="margin-top:0px;" />
                        <div class="col-12" style="color: #606266; font-size: 14px;">
                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">İlkin zərər məbləği (AZN)</div>
                                <div class="col-8">
                                    {{ agreementForm.damageAmount !== null ? formatAmount(agreementForm.damageAmount) :
                                        '—' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">Razılıq növü</div>
                                <div class="col-8">
                                    {{ agreementForm.agreementType === 1 ? 'Şifahi razılıq' :
                                        agreementForm.agreementType === 2 ? 'Müqavilə əsasında razılıq' : 'Təyin olunmayıb'
                                    }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">Güzəşt</div>
                                <div class="col-8">
                                    {{ (agreementForm.discountPercent ?? 0) + '%' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">Razılaşmaya qədər xərclər (AZN)</div>
                                <div class="col-8">
                                    {{ agreementForm.agreementExpense !== null ?
                                        formatAmount(agreementForm.agreementExpense) : '—' }}
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">Yekun razılaşdırılmış məbləğ (AZN)</div>
                                <div class="col-8">
                                    {{ agreementForm.agreedAmount !== null ? formatAmount(agreementForm.agreedAmount) :
                                        '—' }}
                                </div>
                            </div>

                            <el-dialog v-model="invoicesTimelineDialog" title="Hesab-fakturalar" width="40%">
                                <InvoiceTimeline ref="invoiceTimeline" :participant-id="participantId"
                                    @close-timeline="invoicesTimelineDialog = false" @open-print="onOpenPrintInvoice" />
                            </el-dialog>

                            <el-dialog v-model="invoicePrintDialogVisible" width="60%" center top="4vh">
                                <div id="invoice-print-area" ref="printArea" class="print-content">
                                    <div class="d-flex mb-3">
                                        <soft-button id="printButton" v-print="'#invoice-print-area'" color="dark">
                                            <i class="fa-solid fa-print"></i>&nbsp;Çap et
                                        </soft-button>
                                    </div>
                                    <div class="invoice-header">
                                        <div class="invoice-title">Hesab-faktura {{ selectedInvoice?.invoiceNumber }}
                                        </div>
                                    </div>
                                    <div class="invoice-info" style="display: flex; justify-content: space-between;">
                                        <div>
                                            <div style="font-size:15px"><b>Bank:</b> {{ selectedInvoice?.bankName || '—'
                                                }}</div>
                                            <div style="font-size:15px"><b>H/h:</b> {{ selectedInvoice?.accountNumber ||
                                                '—' }}</div>
                                            <div style="font-size:15px"><b>Kod:</b> {{ selectedInvoice?.bankCode || '—'
                                                }}</div>
                                            <div style="font-size:15px"><b>VÖEN:</b> {{ selectedInvoice?.tin || '—' }}
                                            </div>
                                            <div style="font-size:15px"><b>M/h:</b> {{ selectedInvoice?.cbAccount || '—'
                                                }}
                                                <div style="font-size:15px"><b>SWIFT:</b> {{ selectedInvoice?.swift ||
                                                    '—' }}</div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style="font-size:15px"><b>Sığortaçı:</b> ABC Sığorta</div>
                                            <div style="font-size:15px"><b>Ünvan:</b> {{ selectedInvoice?.address || '—'
                                                }}</div>
                                            <div style="font-size:15px"><b>Təqdim olunan (Cavabdeh):</b> {{
                                                selectedInvoice?.debtorName +
                                                " " + selectedInvoice?.debtorSurname || '—' }}</div>
                                            <div v-if="selectedInvoice?.debtorTin" style="font-size:15px">
                                                <b>VÖEN/FİN:</b> {{
                                                    selectedInvoice.debtorTin }}
                                            </div>
                                            <div style="font-size:15px"><b>Tarix:</b> {{
                                                formatDate(selectedInvoice?.createDate) }}</div>
                                        </div>
                                    </div>
                                    <table class="table table-bordered invoice-table">
                                        <thead>
                                            <tr>
                                                <th>№</th>
                                                <th>Tələb / Xidmət</th>
                                                <th class="text-end">Məbləğ (AZN)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Razılaşdırılmış məbləğ</td>
                                                <td class="text-end">{{ formatAmount(selectedInvoice?.agreementAmount)
                                                    }}</td>
                                            </tr>
                                            <tr v-if="selectedInvoice?.preAgreementExpense">
                                                <td>2</td>
                                                <td>Əlavə xərc</td>
                                                <td class="text-end">{{
                                                    formatAmount(selectedInvoice?.preAgreementExpense) }}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td style="font-weight:600; ">Yekun məbləğ</td>
                                                <td class="text-end" style="font-weight:600; ">{{
                                                    formatAmount(selectedInvoice?.totalAmount)
                                                    }}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                    <div v-if="selectedInvoice?.payments?.length" class="payment-schedule">
                                        <div style="font-size:15px;font-weight:600;margin-bottom:4px">Ödəniş cədvəli
                                        </div>
                                        <table class="table table-bordered payment-table">
                                            <thead>
                                                <tr>
                                                    <th>Tarix</th>
                                                    <th class="text-end">Məbləğ (AZN)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(p, idx) in selectedInvoice.payments" :key="idx">
                                                    <td>{{ formatDate2(p.paymentDate) }}</td>
                                                    <td class="text-end">{{ formatAmount(p.amount) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="invoice-footer"
                                        style="display:flex;justify-content:space-between;margin-top:30px">
                                        <div>
                                            <div style="margin-bottom:18px">___________________________<br />
                                                <span style="font-size:13px">Sığorta şirkətinin nümayəndəsi</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div style="margin-bottom:18px">___________________________<br />
                                                <span style="font-size:13px">Cavabdeh şəxs</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-dialog>

                            <el-dialog v-model="invoiceDialogVisible" title="Yeni hesab-faktura" width="450px">
                                <InvoiceDialog :participant-id="participantId" :subrogation-id="subrogationId"
                                    :agreed-amount="agreementForm.agreedAmount"
                                    :agreement-expense="agreementForm.agreementExpense" @saved="onInvoiceSaved"
                                    @cancel="invoiceDialogVisible = false"
                                    @closeTimeline="invoicesTimelineDialog = false" />
                            </el-dialog>
                        </div>
                    </div>
                </div>
                <div class="card h-100">
                    <div class="card-body px-4 py-3">
                        <div class="d-flex justify-content-between align-items-start mb-0">
                            <titles style="margin: 0;" text="Əməliyyatlar" />
                            <div class="d-flex align-items-center">
                                <div v-if="actionData?.createdBy || actionData?.updatedBy"
                                    class="record-label-wrapper position-relative">
                                    <el-button type="default" style="padding: 0px !important" text :icon="InfoFilled"
                                        class="fs-5">
                                    </el-button>
                                    <div class="record-label-tooltip">
                                        <record-label :created="actionData.createdBy" :updated="actionData.updatedBy"
                                            style="color: #606266; font-size: 14px;" />
                                    </div>
                                </div>
                                <!-- <button type="button" class="btn btn-sm bg-white shadow-none p-0 me-1 mb-0"
                                    :disabled="lastStatus === 50" title="Düzəliş et" @click="openEditAction">
                                    <i class="fa-regular fa-edit text-muted fs-5"></i>
                                </button> -->
                            </div>
                        </div>
                        <hr style="margin-top: 0px;" />
                        <div class="col-11" style="color: #606266; font-size: 14px;">
                            <div v-if="lastStatus <= 10">
                                <soft-button type="button" class="btn bg-gradient-danger"
                                    @click="openEditActionWithType(1)">
                                    Xitam
                                </soft-button>
                                &nbsp;
                                <soft-button type="button" class="btn" style="background-color:#606266"
                                    @click="openEditActionWithType(2)">
                                    Məhkəməyə hazırlıq
                                </soft-button>
                            </div>
                            <div class="row mb-2 mt-3">
                                <div class="col-4 font-weight-bold">Əməliyyat növü</div>
                                <div class="col-8">{{ actionTypes[actionData?.actionType] || 'Təyin olunmayıb' }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">Səbəb</div>
                                <div class="col-8">{{ actionReasons[actionData?.actionReason] || '' }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4 font-weight-bold">Qeyd</div>
                                <div class="col-8">{{ actionData?.notes || '' }}</div>
                            </div>
                            <div v-if="lastStatus >= 20 && lastStatus != 50" class="mb-2">
                                <soft-button type="button" class="btn  bg-gradient-success" @click="openPrintDialog">
                                    Məktub
                                </soft-button>
                                &nbsp;
                                <soft-button type="button" :disabled="letterSentDate" class="btn bg-gradient-light"
                                    @click="sendLetter">Məktub göndərildi
                                </soft-button>
                                &nbsp;
                                <soft-button v-if="lastStatus == 20" type="button" class="btn bg-gradient-excel"
                                    :disabled="!letterSentDate" @click="saveParticipantStatus(45)">Öhdəlik
                                    yerinə yetirilib
                                </soft-button>
                                &nbsp;
                                <soft-button v-if="lastStatus == 20" type="button" class="btn btn-gradient-warning"
                                    :disabled="!letterSentDate" @click="saveParticipantStatus(25)">Məhkəmə
                                </soft-button>
                            </div>
                            <div v-if="letterSentDate" class="row mb-2">
                                <div class="col-4 font-weight-bold">Məktubun göndərilmə tarixi</div>
                                <div class="col-8">{{ formatDate(letterSentDate) }}
                                    <span v-if="letterSenderName">,
                                        {{
                                            letterSenderName
                                        }}
                                    </span>
                                </div>
                                <div class="col-4 font-weight-bold">Status</div>
                                <div v-if="actionData && actionData.status" class="col-8">{{ actionData.status }}, {{
                                    formatDate(actionData.statusDate) }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-2">
                    <div class="card-body">
                        <titles text="Sənədlər" />
                        <hr style="margin-top: 0; margin-bottom: 15px;" />
                        <div class="doc-list-table">
                            <div v-for="doc in documentList" :key="doc.id || doc.documentName" class="doc-row">
                                <div class="doc-header-row">
                                    <upload class="upload-root" :sourcetype="1" :source-id="doc.id"
                                        :document-name="doc.documentName" :listtype="'text'" :disabled="false"
                                        :downloadAll="false" @fileUploaded="loadSubrogationDocs" :showTrigger="true" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <Payment :id="subrogationId" :data="subrogationData" :participant="participantId"
                    :agreed-amount="agreementForm.agreedAmount + agreementForm.agreementExpense" :status="lastStatus"
                    :source-type="2" @open-invoice-dialog="openInvoiceDialog"
                    @open-invoices-timeline-dialog="openInvoicesTimelineDialog" />
            </div>
        </div>
    </div>

    <el-dialog v-model="editConsentDialog" title="Razılıq məlumatlarının yenilənməsi" width="40%" top="70px">
        <div class="row px-2 pt-2">
            <div class="col-12 mb-3">
                <label class="form-label">Razılıq növü</label>
                <el-select v-model="editAgreementForm.agreementType" placeholder="Seçin" size="large"
                    style="width: 100%;">
                    <el-option label="Şifahi razılıq" :value="1" />
                    <el-option label="Müqavilə əsasında razılıq" :value="2" />
                </el-select>
            </div>
            <div class="col-12 mb-3">
                <label class="form-label">İlkin zərər məbləği</label>
                <el-input v-model.number="editAgreementForm.damageAmount" type="number" placeholder="Məbləğ"
                    size="large" @input="calculateAgreedAmount" />
            </div>
            <div class="col-12 mb-3">
                <label class="form-label">Güzəşt (%)</label>
                <el-select v-model.number="editAgreementForm.discountPercent" placeholder="Seçin" size="large"
                    style="width: 100%;" @change="calculateAgreedAmount">
                    <el-option v-for="p in [0, 10, 15, 20, 25, 30]" :key="p" :label="p + '%'" :value="p" />
                </el-select>
            </div>
            <div class="col-12 mb-3">
                <label class="form-label">Razılaşmaya qədər xərclər</label>
                <el-input v-model.number="editAgreementForm.agreementExpense" type="number" placeholder="Əlavə xərc"
                    size="large" />
            </div>
            <div class="col-12 mb-3">
                <label class="form-label">Yekun məbləğ</label>
                <el-input v-model.number="editAgreementForm.agreedAmount" type="number" size="large" disabled />
            </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
            <soft-button @click="saveAgreement">Yadda saxla</soft-button>
            &nbsp;
            &nbsp;
            <soft-button color="secondary" @click="editConsentDialog = false">İmtina</soft-button>
        </div>
    </el-dialog>

    <el-dialog v-model="printDialogVisible" width="60%" top="3vh" center>
        <div id="printMe1" ref="printMeRef1">
            <div class="d-flex mb-3">
                <soft-button id="printButton" v-print="'#printMe1'" color="dark">
                    <i class="fa-solid fa-print"></i>&nbsp;Çap et
                </soft-button>
            </div>
            <demand-letter :subrogation-id="subrogationId" :participant-id="participantId" />
        </div>
    </el-dialog>

    <el-dialog v-model="editOperationDialog" title="Əməliyyat məlumatları" width="40%" top="70px">
        <div class="row px-2 pt-2">
            <div class="col-12 mb-3">
                <label class="form-label">Səbəb</label>
                <el-select v-model="operationForm.reason" placeholder="Seçin" size="large" style="width: 100%;"
                    :disabled="!operationForm.operationType">
                    <el-option v-if="operationForm.operationType === 1" :label="'Razılaşdırılmış məbləğ ödənildi'"
                        :value="1" />
                    <el-option v-if="operationForm.operationType === 2" :label="'Razılaşdırılmış məbləğ ödənilmədi'"
                        :value="2" />
                    <el-option v-if="operationForm.operationType === 2" :label="'Razılıq əldə edilmədi'" :value="3" />
                    <el-option :label="'Digər'" :value="0" />
                </el-select>
            </div>
            <div class="col-12 mb-3">
                <label class="form-label">Qeyd</label>
                <el-input v-model="operationForm.note" type="textarea" rows="3" size="large" />
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <soft-button @click="saveOperation">Yadda saxla</soft-button>
            &nbsp;
            &nbsp;
            <soft-button color="secondary" @click="editOperationDialog = false">İmtina</soft-button>
        </div>
    </el-dialog>

    <el-dialog v-model="openRespDialog" :title="isEditMode ? 'Cavabdeh düzəliş' : 'Yeni cavabdeh şəxs'" width="50%"
        top="70px">
        <div class="card-body pt-0">
            <div class="row">
                <div class="d-flex align-items-center" style="width: 48%;">
                    <el-input v-if="personType === 1" v-model="pinSearch" size="large" placeholder="FİN daxil edin"
                        :disabled="!hasPin" clearable style="flex: 1;">
                        <template #prefix>
                            <div class="d-flex align-items-center"
                                style="border-right: 1px solid #dcdfe6; padding-right: 8px; margin-right: 8px;">
                                <el-switch v-model="hasPin" size="large" active-text="Rezident"
                                    inactive-text="Qeyri-rezident" inline-prompt
                                    style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
                            </div>
                        </template>
                    </el-input>

                    <el-input v-if="personType === 2" v-model="voenSearch" size="large" placeholder="VÖEN daxil edin"
                        :disabled="!isLegalSearchActive" clearable style="flex: 1;">
                        <template #prefix>
                            <div class="d-flex align-items-center"
                                style="border-right: 1px solid #dcdfe6; padding-right: 8px; margin-right: 8px;">
                                <el-switch v-model="isLegalSearchActive" size="large" active-text="Rezident"
                                    inactive-text="Qeyri-rezident" inline-prompt
                                    style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
                            </div>
                        </template>
                    </el-input>

                    <soft-button type="button" color="info" class="ms-2" style="padding: 10px 16px; min-width: 48px;"
                        :disabled="personType === 1 && !hasPin" @click="searchRespPerson">
                        <i class="fa fa-search"></i>
                    </soft-button>
                </div>

                <div class="col-md-12 mt-3">
                    <el-radio-group v-model="personType" size="large">
                        <el-radio :value="1">Fiziki şəxs</el-radio>
                        <el-radio :value="2">Hüquqi şəxs</el-radio>
                    </el-radio-group>
                </div>

                <div v-if="personType === 1" class="row w-100">
                    <div class="col-md-6 mt-3">
                        <label class="form-label">FİN</label>
                        <el-input v-model="respForm.pin" size="large" :disabled="hasPin" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Cins</label>
                        <el-select v-model="respForm.gender" size="large" placeholder="Seçin" style="width: 100%;"
                            :disabled="hasPin">
                            <el-option label="Kişi" :value="1" />
                            <el-option label="Qadın" :value="2" />
                        </el-select>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Ad</label>
                        <el-input v-model="respForm.name" size="large" :disabled="hasPin" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Əlaqə nömrəsi</label>
                        <el-input v-model="respForm.mobilePhone" v-mask="'+994 (##) ###-##-##'" size="large"
                            placeholder="+994-(##)-123-45-66" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Soyad</label>
                        <el-input v-model="respForm.surname" size="large" :disabled="hasPin" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Əlavə əlaqə nömrəsi</label>
                        <el-input v-model="respForm.additionalMobilePhone" v-mask="'+994 (##) ###-##-##'" size="large"
                            placeholder="+994-(##)-123-45-66" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Ata adı</label>
                        <el-input v-model="respForm.fatherName" size="large" :disabled="hasPin" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">İş yeri</label>
                        <el-input v-model="respForm.workplace" size="large" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Doğum tarixi</label>
                        <el-date-picker v-model="respForm.dateOfBirth" size="large" placeholder="Seçin" type="date"
                            format="DD.MM.YYYY" value-format="YYYY-MM-DD" style="width: 100%;" :disabled="hasPin" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Faktiki yaşayış ünvanı</label>
                        <el-input v-model="respForm.regAddress" size="large" />
                    </div>
                </div>
                <div v-if="personType === 2" class="row w-100">
                    <div class="col-md-6 mt-3">
                        <label class="form-label">VÖEN</label>
                        <el-input v-model="respForm.tin" size="large" :disabled="isLegalSearchActive" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Faktiki yaşayış ünvanı</label>
                        <el-input v-model="respForm.regAddress" size="large" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Ad</label>
                        <el-input v-model="respForm.name" size="large" :disabled="isLegalSearchActive" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Mobil nömrə</label>
                        <el-input v-model="respForm.mobilePhone" size="large" placeholder="+994-(##)-123-45-66" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Nümayəndə</label>
                        <el-input v-model="respForm.representative" size="large" />
                    </div>
                    <div class="col-md-6 mt-3">
                        <label class="form-label">Əlavə nömrə</label>
                        <el-input v-model="respForm.additionalMobilePhone" size="large"
                            placeholder="+994-(##)-123-45-66" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row dialog-btn mt-4">
            <div class="d-flex justify-content-end">
                <soft-button type="button" @click="saveParticipantUpdate">
                    Yadda saxla
                </soft-button>
                &nbsp;
                &nbsp;
                <soft-button type="button" color="secondary" @click="openRespDialog = false">
                    İmtina
                </soft-button>
            </div>
        </div>
    </el-dialog>

</template>

<script>
import { CreateAgreement, GetSubrogationAgreement } from "@/project/Source/agreements";
import Titles from "@/project/Components/Titles.vue";
import Payment from "@/project/Components/Payment.vue";
import { GetSubrogationById } from "@/project/Source/subrogations";
import { GetSubrogationParticipant, UpdateParticipant, LastParticipantStatus, UpdateParticipantStatus } from "@/project/Source/participants";
import SoftButton from "@/components/SoftButton.vue";
import RecordLabel from "@/project/Components/RecordLabel.vue";
import { DateToString, respPersonData } from "@/project/Source/helper";
import { CreateAction, GetAction } from "@/project/Source/actions";
import ParticipantInfo from "@/project/PreCourt/Components/ParticipantInfo.vue";
import DemandLetter from "@/project/Components/DemandLetter.vue";
import { CreateCourtPreparation, GetCourtPreparation } from "@/project/Source/courtpreparations";
import InvoiceDialog from "@/project/Components/Dialogs/InvoiceDialog.vue";
import InvoiceTimeline from "@/project/Components/InvoiceTimeline.vue";
import { mask } from "vue-the-mask";
import { Edit, InfoFilled } from "@element-plus/icons-vue";
import Upload from "@/project/Components/Upload.vue";
import { GetSubrogationDocs } from "@/project/Source/subrogationdoc";

export default {
    directives: {
        mask,
    },
    components: {
        Payment,
        Titles,
        SoftButton,
        RecordLabel,
        ParticipantInfo,
        DemandLetter,
        InvoiceDialog,
        InvoiceTimeline,
        Upload
    },
    data() {
        return {
            Edit,
            InfoFilled,
            invoicePrintDialogVisible: false,
            selectedInvoice: null,
            letterSentDate: null,
            printDialogVisible: false,
            actionData: null,
            subrogationId: null,
            participantId: null,
            subrogationData: {},
            participantData: {},
            loading: false,
            openedDocs: [],
            editConsentDialog: false,
            editOperationDialog: false,
            operationForm: {
                operationType: null,
                reason: "",
                note: ""
            },
            documentList: [],
            letterSenderName: null,
            openRespDialog: false,
            isEditMode: false,
            personType: 1,
            hasPin: true,
            isLegalSearchActive: true,
            pinSearch: "",
            voenSearch: "",
            respForm: {
                pin: "",
                name: "",
                surname: "",
                fatherName: "",
                mobilePhone: "",
                additionalMobilePhone: "",
                gender: null,
                dateOfBirth: "",
                regAddress: "",
                workplace: "",
                tin: "",
                representative: ""
            },
            lastStatus: null,
            agreementForm: {
                agreementType: null,
                damageAmount: null,
                discountPercent: 0,
                agreedAmount: 0,
                agreementExpense: null
            },
            editAgreementForm: {
                agreementType: null,
                damageAmount: null,
                discountPercent: 0,
                agreedAmount: 0,
                agreementExpense: null
            },
            actionTypes: {
                1: 'Xitam',
                2: 'Məhkəməyə hazırlıq',
            },
            actionReasons: {
                1: 'Razılaşdırılmış məbləğ ödənildi',
                2: 'Razılaşdırılmış məbləğ ödənilmədi',
                3: 'Razılıq əldə edilmədi',
                0: 'Digər'
            },
            invoiceDialogVisible: false,
            invoicesTimelineDialog: false,

        };
    },
    watch: {
        editConsentDialog(val) {
            if (val) {
                this.loadAgreement();
            }
        }
    },
    mounted() {
        this.subrogationId = this.$route.params.subrogationId;
        this.participantId = this.$route.params.participantId;
        this.loadSubrogationData();
        this.loadParticipantData();
        this.loadAgreement();
        this.loadAction();
        this.getLastParticipantStatus();
        this.loadData();
        this.loadSubrogationDocs();
    },
    methods: {
        async loadSubrogationDocs() {
            try {
                const resp = await GetSubrogationDocs(this.subrogationId, this.participantId, 0, 0);
                this.documentList = (resp.data.data || []).map(doc => {
                    let files = [];
                    if (doc.fileName && doc.url) {
                        const names = doc.fileName.split(',').map(x => x.trim());
                        const urls = doc.url.split(',').map(x => x.trim());
                        files = names.map((name, idx) => ({
                            fileName: name,
                            url: urls[idx] || '',
                            status: 'ok'
                        }));
                    }
                    return {
                        ...doc,
                        files
                    };
                });
            } catch (e) {
                this.$message.error("Sənədləri yükləmək mümkün olmadı");
            }
        },
        formatAmount(value) {
            if (value == null) return "-";
            let parts = Number(value).toFixed(2).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(',');
        },
        openInvoiceDialog() {
            this.invoiceDialogVisible = true
        },
        openInvoicesTimelineDialog() {
            this.invoicesTimelineDialog = true
        },
        onOpenPrintInvoice(invoice) {
            this.selectedInvoice = invoice;
            this.invoicesTimelineDialog = false;
            this.$nextTick(() => {
                this.invoicePrintDialogVisible = true;
            });
        },
        onInvoiceSaved(invoiceId) {
            this.invoiceDialogVisible = false;
            this.invoicesTimelineDialog = true;
            this.$nextTick(() => {
                this.$refs.invoiceTimeline && this.$refs.invoiceTimeline.openPrint(invoiceId);
            });
        },
        async saveParticipantStatus(statusTypeId) {
            const result = await this.$swal({
                title: "Təsdiq edin",
                text: "Əməliyyatı təsdiq edirsiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "İmtina",
                confirmButtonText: "Təsdiq et",
                customClass: {
                    confirmButton: "btn bg-gradient-info",
                    cancelButton: "btn bg-gradient-secondary",
                },
                buttonsStyling: false,
            });

            if (!result.isConfirmed) return;
            this.loading = true;
            try {
                let payload = {
                    participantId: this.participantId,
                    id: this.subrogationId,
                    statusTypeId: statusTypeId,
                    user: this.$store.state.user.id,
                };
                await UpdateParticipantStatus(payload);
                this.$message.success("Uğurlu əməliyyat!");
                await this.getLastParticipantStatus();
                await this.loadAction();
            } catch (e) {
                this.$message.error("Xəta baş verdi!");
                console.error(e);
            } finally {
                this.loading = false;
            }
        },
        formatDate2(dt) {
            if (!dt) return "-";
            const d = new Date(dt);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}.${mm}.${yyyy}`;
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            const d = new Date(dateString);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
        },
        async loadData() {
            this.loading = true;
            try {
                const resp = await GetCourtPreparation(this.subrogationId, this.participantId);
                const d = resp.data.data[0] || {};
                this.letterSentDate = d.letterSentDate || null;
                this.letterSenderName = d.createUserName || null;
                this.letterSent = !!this.letterSentDate;
                this.executorMeta = {
                    createdBy: d.createdBy || null,
                    updatedBy: d.updatedBy || null,
                };
            } catch (e) {
                console.error('Error loading court preparation:', e);
            } finally {
                this.loading = false;
            }
        },
        openPrintDialog() {
            this.printDialogVisible = true;
        },
        getLastParticipantStatus() {
            LastParticipantStatus(this.participantId)
                .then(response => {
                    this.lastStatus = response.data;
                })
                .catch(error => {
                    console.error("Failed to load last status:", error);
                });
        },
        openAgreementDialog() {
            this.editAgreementForm = JSON.parse(JSON.stringify(this.agreementForm));
            this.editConsentDialog = true;
        },
        calculateAgreedAmount() {
            const base = this.editAgreementForm.damageAmount || 0;
            const discount = this.editAgreementForm.discountPercent || 0;
            this.editAgreementForm.agreedAmount = +(base * (1 - discount / 100)).toFixed(2);
        },
        saveAgreement() {
            const payload = {
                subrogationId: this.subrogationId,
                participantId: this.participantId,
                ...this.editAgreementForm,
                createUser: this.$store.state.user.id
            };

            this.loading = true;
            CreateAgreement(payload)
                .then((response) => {
                    if (response.data?.isSuccess) {
                        this.$message.success("Uğurlu əməliyyat!");
                        this.agreementForm = { ...this.editAgreementForm };
                        this.editConsentDialog = false;
                    } else {
                        this.$message.error(response.data?.message || "Xəta baş verdi");
                    }
                })
                .catch((error) => {
                    this.$message.error(
                        error.response?.data?.message ||
                        (typeof error.response?.data === "string" ? error.response.data : null) ||
                        error.message || "Xəta baş verdi"
                    );
                })
                .finally(() => this.loading = false);
        },
        loadAgreement() {
            GetSubrogationAgreement(this.participantId)
                .then(res => {
                    if (res.data) {
                        this.agreementForm = {
                            agreementType: res.data.data[0].agreementType,
                            damageAmount: res.data.data[0].damageAmount,
                            discountPercent: res.data.data[0].discountPercent,
                            agreedAmount: res.data.data[0].agreedAmount,
                            agreementExpense: res.data.data[0].agreementExpense,
                            createdBy: res.data.data[0].createdBy || "",
                            updatedBy: res.data.data[0].updatedBy || ""
                        };
                    }
                });
        },
        openEditActionWithType(type) {
            this.operationForm = {
                operationType: type,
                reason: '',
                note: ''
            };
            this.editOperationDialog = true;
        },
        openEditAction() {
            this.operationForm = {
                operationType: this.actionData?.actionType ?? null,
                reason: this.actionData?.actionReason ?? "",
                note: this.actionData?.notes ?? ""
            };

            this.editOperationDialog = true;
        },
        loadAction() {
            if (!this.participantId) return;

            GetAction(this.participantId)
                .then(res => {
                    this.actionData = res.data.data[0] || null;
                })
                .catch(() => {
                    this.actionData = null;
                });
        },
        saveOperation() {
            if (
                this.operationForm.operationType == null ||
                this.operationForm.reason === null ||
                this.operationForm.reason === ''
            ) {
                this.$message.warning("Zəhmət olmasa bütün sahələri doldurun.");
                return;
            }

            this.loading = true;

            const payload = {
                subrogationId: this.subrogationId,
                actionType: this.operationForm.operationType,
                actionReason: Number(this.operationForm.reason),
                notes: this.operationForm.note,
                subrogationid: this.subrogationId,
                participantid: this.participantId,
                user: this.$store.state.user.id
            };

            CreateAction(payload)
                .then(() => {
                    this.$message.success("Əməliyyat uğurla əlavə olundu");
                    this.editOperationDialog = false;
                    this.operationForm = { operationType: null, reason: "", note: "" };
                    this.loadAction();
                    this.getLastParticipantStatus();
                })
                .catch(() => {
                    this.$message.error("Xəta baş verdi");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        DateToString,
        loadParticipantData() {
            if (!this.participantId) return;

            this.loading = true;

            GetSubrogationParticipant(this.participantId)
                .then(response => {
                    this.participantData = response.data.data[0] || {};
                })
                .catch(error => {
                    console.error("Failed to load participant:", error);
                    this.$message.error("İştirakçı məlumatı yüklənə bilmədi.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadSubrogationData() {
            this.loading = true;
            GetSubrogationById(this.subrogationId)
                .then((response) => {
                    this.subrogationData = response.data.data[0] || {};
                })
                .catch((error) => {
                    console.error("Failed to load subrogation:", error);
                    this.$message.error("Məlumatlar yüklənə bilmədi.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        goBack() {
            window.history.back();
        },
        openEditParticipant() {
            this.respForm = {
                pin: this.participantData.pin || "",
                name: this.participantData.name || "",
                surname: this.participantData.surname || "",
                fatherName: this.participantData.fatherName || "",
                gender: this.participantData.gender || null,
                dateOfBirth: this.participantData.birthDate || "",
                mobilePhone: this.participantData.phone || "",
                additionalMobilePhone: this.participantData.additionalPhone || "",
                workplace: this.participantData.workPlace || "",
                regAddress: this.participantData.regAddress || "",
                tin: this.participantData.tin || "",
                representative: this.participantData.representative || ""
            };

            this.personType = this.participantData.personType || 1;
            this.isEditMode = true;
            this.openRespDialog = true;
        },

        saveParticipantUpdate() {
            this.loading = true;
            const isPhysical = this.personType === 1;
            const payload = {
                id: this.participantId,
                subrogationId: this.subrogationId,
                name: this.respForm.name,
                pin: this.respForm.pin,
                tin: !isPhysical ? this.respForm.tin : null,
                surname: isPhysical ? this.respForm.surname : null,
                fatherName: isPhysical ? this.respForm.fatherName : null,
                gender: isPhysical ? this.respForm.gender : null,
                birthDate: isPhysical ? this.respForm.dateOfBirth : null,
                workPlace: isPhysical ? this.respForm.workplace : null,
                representative: !isPhysical ? this.respForm.representative : null,
                phone: this.respForm.mobilePhone,
                additionalPhone: this.respForm.additionalMobilePhone,
                regAddress: this.respForm.regAddress,
                personType: this.personType,
                commandUserId: this.$store.state.user.id
            };

            UpdateParticipant(payload)
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.openRespDialog = false;
                    this.loadParticipantData();
                })
                .catch(() => {
                    this.$message.error("Xəta baş verdi");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async sendLetter() {
            this.loading = true;
            try {
                await CreateCourtPreparation({
                    subrogationId: this.subrogationId,
                    participantId: this.participantId,
                    user: this.$store.state.user.id,
                });
                this.$message.success('Məktub göndərildi');
                this.printDialogVisible = false;

                await this.getLastParticipantStatus();
                await this.loadData();
            } catch (e) {
                console.error('Error sending letter:', e);
            } finally {
                this.loading = false;
            }
        },

        searchRespPerson() {
            if (this.personType === 1) {
                const match = respPersonData.find(p => p.pin === this.pinSearch);
                if (match) {
                    this.respForm = { ...match };
                    this.pinSearch = "";
                } else {
                    this.$message.warning("FİN tapılmadı");
                }
            } else if (this.personType === 2) {
                const match = respPersonData.find(p => p.tin === this.voenSearch);
                if (match) {
                    this.respForm = { ...match };
                    this.voenSearch = "";
                } else {
                    this.$message.warning("VÖEN tapılmadı");
                }
            }
        },


    },
};
</script>


<style scoped>
.record-label-wrapper {
    position: relative;
}

.record-label-tooltip {
    display: block;
    position: absolute;
    top: 100%;
    right: 0;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    z-index: 1000;
    min-width: 180px;
    opacity: 0;
    transform: translateY(5px);
    pointer-events: none;
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.record-label-wrapper:hover .record-label-tooltip {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
}

.invoice-table,
.invoice-table th,
.invoice-table td,
.payment-table,
.payment-table th,
.payment-table td {
    border: 1.6px solid #606266 !important;
}

td {
    padding: 12px 24px !important;
}


.badge-active {
    background: #eafbe7;
    color: #299c47;
    border-radius: 6px;
    padding: 2px 10px;
    font-size: 13px;
    margin-left: 8px;
}

.print-content {
    background: #fff;
    padding: 24px 28px 36px 28px;
    min-height: 440px;
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #606266;
    padding-bottom: 16px;
}

.invoice-title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
}

.invoice-info {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    margin-bottom: 8px;
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
    font-size: 15px;
}

.payment-schedule {
    margin-top: 28px;
}

.payment-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.invoice-footer {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
}

.col-8 {
    color: #222222;
}

.doc-header-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
}



@media print {

    #printButton,
    #sendButton {
        display: none !important;
    }
}
</style>